export const CANAIS_META_PAGE_LIST_DESIGN = {
    page: {
        container: "flex flex-col h-full w-full gap-6 p-2 md:p-0 pb-12 animate-in fade-in slide-in-from-bottom-4 duration-500",
        header: {
            container: "flex items-start gap-4",
            iconBox: "w-11 h-11 rounded-2xl flex items-center justify-center bg-[#7C3AED]/10 text-[#7C3AED] shrink-0",
            title: "text-2xl font-bold text-gray-900 tracking-tight",
            subtitle: "text-sm text-gray-500 mt-1",
        },
        content: "max-w-xl w-full",
    },
    step: {
        container: "flex flex-col gap-3",
        header: "flex items-center gap-2.5",
        badge: "w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold shrink-0",
        badgeActive: "bg-[#7C3AED] text-white",
        badgeDone: "bg-emerald-500 text-white",
        badgePending: "bg-gray-200 text-gray-500",
        title: "text-sm font-semibold text-gray-900",
        subtitle: "text-xs text-gray-500 pl-[34px] -mt-1.5",
    },
    item: {
        base: "group flex items-center gap-3 border rounded-xl p-3 transition-all duration-200",
        selectable: "cursor-pointer hover:shadow-md",
        selected: "border-[#7C3AED] bg-[#7C3AED]/5 shadow-sm shadow-[#7C3AED]/10",
        unselected: "border-gray-200 bg-white hover:border-gray-300 hover:bg-gray-50",
        disabledLook: "opacity-60 cursor-not-allowed",
        avatarWrap: "w-11 h-11 rounded-xl overflow-hidden bg-gray-100 shrink-0 flex items-center justify-center",
        avatarImg: "w-full h-full object-cover",
        name: "text-sm font-semibold text-gray-900 truncate",
        meta: "text-xs text-gray-500 truncate",
        checkOn: "text-[#7C3AED]",
        checkOff: "text-gray-300",
    },
    skeletonRow: "flex items-center gap-3 border border-gray-100 rounded-xl p-3 bg-white",
    empty: "flex flex-col items-center justify-center py-10 px-4 bg-gray-50/60 border-2 border-dashed border-gray-200 rounded-xl text-center",
    error: "flex flex-col items-center gap-3 py-8 px-4 bg-red-50 border border-red-100 rounded-xl text-center",
    footer: {
        container: "flex flex-col gap-4 pt-2",
        consent: "flex flex-wrap items-center gap-1 text-xs text-gray-500",
        link: "text-[#7C3AED] font-medium hover:underline",
        primaryButton: "!h-auto flex items-center justify-center gap-2 px-4 py-2.5 bg-[#7C3AED] hover:bg-[#6d28d9] text-white text-sm font-medium rounded-xl transition-all shadow-sm shadow-[#7C3AED]/20 active:transform active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed disabled:active:scale-100 border-none w-full",
    },
    successOverlay: {
        backdrop: "fixed inset-0 bg-gray-900/40 backdrop-blur-sm flex items-center justify-center z-50 animate-in fade-in duration-200",
        card: "bg-white rounded-xl p-6 max-w-sm w-full mx-4 shadow-xl border border-gray-100 flex flex-col items-center text-center",
        iconBox: "w-12 h-12 bg-emerald-50 rounded-full flex items-center justify-center mb-4 text-emerald-500",
        title: "text-lg font-bold text-gray-900 mb-2",
        message: "text-sm text-gray-500 leading-relaxed mb-6",
    },
    modal: {
        backdrop: "fixed inset-0 bg-gray-900/40 backdrop-blur-sm flex items-center justify-center z-50 p-4 animate-in fade-in duration-200",
        card: "bg-white rounded-xl shadow-xl border border-gray-100 max-w-2xl w-full max-h-[80vh] flex flex-col overflow-hidden",
        header: "flex items-center justify-between px-6 py-4 border-b border-gray-100 shrink-0",
        title: "text-base font-bold text-gray-900",
        body: "flex-1 overflow-y-auto px-6 py-4 text-sm text-gray-600 leading-relaxed",
        footer: "flex justify-end px-6 py-4 border-t border-gray-100 shrink-0",
    },
};
